import { Query } from "@syncfusion/ej2-data";
import { DropDownListComponent } from "@syncfusion/ej2-react-dropdowns";
import {
  ColumnDirective,
  ColumnsDirective,
  ExcelExport,
  GridComponent,
  Inject,
  Page,
  Resize,
  Search,
  Sort,
  Toolbar,
} from "@syncfusion/ej2-react-grids";
import axios from "axios";
import { getCookie } from "cookies-next";
import React, { useEffect, useRef, useState } from "react";
import { FaEye, FaPlus, FaSignature, FaTrash, FaXmark } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { FaEdit, FaSync } from "react-icons/fa";
import { Header, PageLoading } from "../../../components";
import { API_ROOT } from "../../../config";
import { useStateContext } from "../../../contexts/ContextProvider";
import "../../table.css";

const SignatureSpecimen = () => {
  const navigate = useNavigate();
  const { currentColor } = useStateContext();

  const [pageLoading, setPageLoading] = useState(true);
  const [signatureList, setSignatureList] = useState([]);
  const [refresh, setRefresh] = useState(0);
  const [toggleAdd, setToggleAdd] = useState(false);
  const [toggleEdit, setToggleEdit] = useState(false);
  const [toggleDelete, setToggleDelete] = useState(false);
  const [toggleSync, setToggleSync] = useState(false);
  const [toggleSignatureImg, setToggleSignatureImg] = useState(false);

  // Master data
  const [integratedMembers, setIntegratedMembers] = useState([]);
  const [integratedPlatforms, setIntegratedPlatforms] = useState([]);
  const [ttdTypes] = useState([
    { text: "Signature", value: "signature" },
    { text: "Paraf", value: "paraf" },
  ]);

  const [signatureData, setSignatureData] = useState({
    uuid: null,
    integrated_platform_id: null,
    integrated_member_id: null,
    type_ttd: null,
    filepath: null,
  });

  const [selectedSignatureSource, setSelectedSignatureSource] =
    useState("upload"); //"userDetail", "upload",
  const [selectedIntegratedMember, setSelectedIntegratedMember] =
    useState(null);

  const [signatureWarning, setSignatureWarning] = useState({
    integrated_member_id: null,
    type_ttd: null,
    filepath: null,
  });

  const [syncSignatureData, setSyncSignatureData] = useState({
    integrated_platform_id: null,
    integrated_member_id: null,
  });

  const [syncSignatureWarning, setSyncSignatureWarning] = useState({
    integrated_member_id: null,
  });

  const [signatureDisabled, setSignatureDisabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const gridRef = useRef(null);

  const formatDate = (inputDate) => {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const date = new Date(inputDate);
    const dayOfWeek = days[date.getUTCDay()];
    const day = date.getUTCDate();
    const month = months[date.getUTCMonth()];
    const year = date.getUTCFullYear();
    const hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    const seconds = date.getUTCSeconds();

    return `${dayOfWeek}, ${day} ${month} ${year} ${hours
      .toString()
      .padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
  };

  const fetchIntegratedPlatforms = async () => {
    try {
      const response = await axios.get(
        API_ROOT + "/admin/user/integrated-platform/list?offset=1&limit=all",
        {
          headers: { Authorization: getCookie("admin_auth") },
        },
      );
      setIntegratedPlatforms(
        response.data.data.map((item) => ({
          text: item.platform_name,
          value: item.uuid,
          id: item.id,
        })),
      );
    } catch (error) {
      console.log("Failed to fetch integrated members:", error);
      if (error.response?.status === 401) {
        navigate("/login");
      }
    }
  };

  const fetchIntegratedMembers = async (platformUuid) => {
    try {
      const response = await axios.get(
        API_ROOT +
          "/admin/user/integrated-member/list?offset=1&limit=all&platformUuid=" +
          platformUuid,
        {
          headers: { Authorization: getCookie("admin_auth") },
        },
      );
      setIntegratedMembers(
        response.data.data.map((item) => ({
          text: item.user.name,
          value: item.uuid,
          platform_id: item.integrated_platform_id,
          ttd_signature: item.user?.user_detail?.ttd_signature,
          ttd_paraf: item.user?.user_detail?.ttd_paraf,
        })),
      );

      if (signatureData.integrated_member_id) {
        setSelectedIntegratedMember(
          integratedMembers?.find(
            (im) => signatureData.integrated_member_id == im?.value,
          ),
        );
      }
    } catch (error) {
      console.log("Failed to fetch integrated members:", error);
      if (error.response?.status === 401) {
        navigate("/login");
      }
    }
  };

  const fetchData = async () => {
    try {
      const response = await axios.get(
        API_ROOT + "/admin/specimen-signature/list?offset=1&limit=all",
        {
          headers: {
            Authorization: getCookie("admin_auth"),
          },
        },
      );

      const data = response.data.data;
      setSignatureList(() =>
        data.map((item, index) => ({
          No: index + 1,
          Uuid: item.uuid,
          IntegratedMemberName: item.integrated_member?.user?.name || "-",
          IntegratedPlatformName:
            item.integrated_member?.integrated_platform?.platform_name || "-",
          TypeTtd: item.type_ttd,
          Filepath: item.uuid,
          CreatedAt: formatDate(item.created_at),
        })),
      );
      setPageLoading(false);
    } catch (error) {
      if (error.response?.status === 401) {
        navigate("/login");
        return;
      }
      console.log(error);
      toast.error("Failed to get data");
      setPageLoading(false);
    }
  };

  const fetchSignatureDetail = async (uuid) => {
    try {
      const response = await axios.get(
        API_ROOT + "/admin/specimen-signature/detail/" + uuid,
        {
          headers: { Authorization: getCookie("admin_auth") },
        },
      );

      const data = response.data.data;
      setSignatureData({
        uuid: data.specimenId,
        integrated_platform_id: data.integrated_member.integrated_platform.uuid,
        integrated_member_id: data.integrated_member.uuid,
        type_ttd: data.type_ttd,
        filepath: data.filepath,
      });

      setSelectedIntegratedMember(
        integratedMembers?.find(
          (im) => signatureData.integrated_member_id == im?.value,
        ),
      );
      setSelectedSignatureSource("upload");

      await fetchIntegratedMembers(
        data.integrated_member.integrated_platform.uuid,
      );
    } catch (error) {
      toast.error("Failed to fetch signature details");
      console.log(error);
    }
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.type !== "image/png") {
        toast.error("Error: File harus berformat PNG!");
        return;
      }
      const maxSize = 1 * 1024 * 1024;
      if (file.size > maxSize) {
        toast.error("Error: Ukuran file maksimal 1 MB!");
        return;
      }

      const reader = new FileReader();
      reader.onload = (event) => {
        setSignatureData((prev) => ({
          ...prev,
          filepath: event.target.result.split(",")[1],
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {
    setPageLoading(true);
    setSignatureList([]);
    setToggleAdd(false);
    setToggleEdit(false);
    setToggleDelete(false);
    setToggleSync(false);
    setToggleSignatureImg(false);
    setLoading(false);
    setSignatureDisabled(false);
    fetchData();
    fetchIntegratedPlatforms();
  }, [refresh]);

  useEffect(() => {
    const warnings = Object.values(signatureWarning);
    for (const value of warnings) {
      if (value !== null) {
        return;
      }
    }
  }, [signatureWarning]);

  const actionTemplate = (props) => {
    return (
      <div className="e-actionParent flex gap-2">
        <button
          className="e-action"
          onClick={() =>
            navigate(`/markany/signature-specimen/detail/${props.Uuid}`)
          }
        >
          <FaEye className="e-actionIcon" />
          <div>Detail</div>
        </button>
        <button className="e-action" onClick={() => handleEdit(props)}>
          <FaEdit className="e-actionIcon" />
          <div>Edit</div>
        </button>
        <button
          className="e-action text-red-600"
          onClick={() => handleDelete(props)}
        >
          <FaTrash className="e-actionIcon" />
          <div>Delete</div>
        </button>
      </div>
    );
  };

  const signatureImgTemplate = (props) => {
    return (
      <button
        className="e-action"
        onClick={() => handleSignatureImgShow(props)}
      >
        <FaSignature className="e-actionIcon" />
        <div>Signature Image</div>
      </button>
    );
  };

  const handleAdd = () => {
    resetForm();
    setToggleAdd(true);
    setIntegratedMembers([]);
  };

  const handleEdit = async (data) => {
    setIntegratedMembers([]);
    await fetchSignatureDetail(data.Uuid);
    setToggleEdit(true);
  };

  const handleSignatureImgShow = async (data) => {
    await fetchSignatureDetail(data.Uuid);
    setToggleSignatureImg(true);
  };

  const handleDelete = async (data) => {
    await fetchSignatureDetail(data.Uuid);
    setToggleDelete(true);
  };

  const handleSync = () => {
    setIntegratedMembers([]);
    resetSyncForm();
    setToggleSync(true);
  };

  const queryCellInfo = (args) => {
    args.cell?.classList.add("e-cell");
  };

  function onIntegratedPlatformFiltering(args) {
    let query = new Query();
    query =
      args.text !== ""
        ? query.where("text", "contains", args.text, true)
        : query;
    args.updateData(integratedPlatforms, query);
  }

  function onIntegratedMemberFiltering(args) {
    let query = new Query();
    query =
      args.text !== ""
        ? query.where("text", "contains", args.text, true)
        : query;
    args.updateData(integratedMembers, query);
  }

  const dataBound = () => {
    if (gridRef.current) {
      gridRef.current.autoFitColumns([
        "No",
        "IntegratedMemberName",
        "IntegratedPlatformName",
        "TypeTtd",
        "Filepath",
        "CreatedAt",
        "Uuid",
      ]);
    }
  };

  const toolbarClick = (args) => {
    if (gridRef.current && args.item.id.includes("excelexport")) {
      const excelExportProperties = {
        fileName: "Paperless - Signature List.xlsx",
      };
      gridRef.current.excelExport(excelExportProperties);
    }
  };

  const resetForm = () => {
    setSelectedSignatureSource("upload");
    setSignatureData({
      uuid: null,
      integrated_member_id: null,
      type_ttd: null,
      filepath: null,
    });
    setSignatureWarning({
      integrated_member_id: null,
      type_ttd: null,
      filepath: null,
    });
  };

  const resetSyncForm = () => {
    setSyncSignatureData({
      integrated_platform_id: null,
      integrated_member_id: null,
    });
    setSyncSignatureWarning({
      integrated_member_id: null,
    });
  };

  const validateForm = () => {
    let isValid = true;
    const warnings = { ...signatureWarning };

    if (!signatureData.integrated_member_id) {
      warnings.integrated_member_id = "Integrated Member is required";
      isValid = false;
    } else {
      warnings.integrated_member_id = null;
    }

    if (!signatureData.type_ttd) {
      warnings.type_ttd = "Type TTD is required";
      isValid = false;
    } else {
      warnings.type_ttd = null;
    }

    if (
      selectedSignatureSource == "upload" &&
      (!signatureData.filepath || signatureData.filepath.trim().length < 1)
    ) {
      warnings.filepath = "Filepath is required";
      isValid = false;
    } else {
      warnings.filepath = null;
    }

    setSignatureWarning(warnings);
    return isValid;
  };

  const handleSubmit = async (isEdit = false) => {
    if (!validateForm()) return;

    setLoading(true);

    try {
      let filepath = signatureData.filepath;

      if (selectedSignatureSource == "userDetail") {
        if (signatureData.type_ttd == "signature") {
          if (selectedIntegratedMember.ttd_signature) {
            filepath = selectedIntegratedMember.ttd_signature;
          } else {
            toast.error(
              "*Member tidak mempunyai data signature, silahkan upload custom specimen",
            );
            setLoading(false);
            return;
          }
        }
        if (signatureData.type_ttd == "paraf") {
          if (selectedIntegratedMember.ttd_paraf) {
            filepath = selectedIntegratedMember.ttd_paraf;
          } else {
            toast.error(
              "*Member tidak mempunyai data signature, silahkan upload custom specimen",
            );
            setLoading(false);
            return;
          }
        }
      }
      const payload = {
        integrated_member_id: signatureData.integrated_member_id,
        type_ttd: signatureData.type_ttd,
        filepath: filepath,
      };

      if (isEdit) {
        await axios.put(
          API_ROOT + "/admin/specimen-signature/update/" + signatureData.uuid,
          payload,
          {
            headers: { Authorization: getCookie("admin_auth") },
          },
        );
        toast.success("Signature Updated!");
      } else {
        await axios.post(
          API_ROOT + "/admin/specimen-signature/create",
          payload,
          {
            headers: { Authorization: getCookie("admin_auth") },
          },
        );
        toast.success("Signature Created!");
      }

      setToggleAdd(false);
      setToggleEdit(false);
      setRefresh((prev) => prev + 1);
    } catch (error) {
      toast.error(error.response?.data?.message || "Server Error");

      if (error.response?.status === 401) {
        navigate("/login");
      }
    }

    setLoading(false);
  };

  const handleSyncSubmit = async () => {
    if (!syncSignatureData.integrated_member_id) {
      setSyncSignatureWarning({
        integrated_member_id: "Integrated Member is required",
      });
      return;
    } else {
      setSyncSignatureWarning({
        integrated_member_id: null,
      });
    }

    setLoading(true);

    try {
      const payload = {
        integrated_member_id: syncSignatureData.integrated_member_id,
      };

      await axios.post(API_ROOT + "/admin/specimen-signature/sync", payload, {
        headers: { Authorization: getCookie("admin_auth") },
      });
      toast.success("Membership Sync!");

      setToggleSync(false);
      setRefresh((prev) => prev + 1);
    } catch (error) {
      toast.error(error.response?.data?.message || "Server Error");

      if (error.response?.status === 401) {
        navigate("/login");
      }
    }

    setLoading(false);
  };

  const handleDeleteConfirm = async () => {
    setDeleteLoading(true);

    try {
      await axios.delete(
        API_ROOT + "/admin/signature/delete/" + signatureData.uuid,
        {
          headers: { Authorization: getCookie("admin_auth") },
        },
      );

      toast.success("Signature Deleted!");
      setToggleDelete(false);
      setRefresh((prev) => prev + 1);
    } catch (error) {
      toast.error("Failed to delete signature!");

      if (error.response?.status === 401) {
        navigate("/login");
      }
    }

    setDeleteLoading(false);
  };

  const renderFormFields = () => (
    <div className="flex flex-col gap-4 w-fit">
      <div className="flex flex-col gap-2">
        <h4 className="font-medium">Integrated Platform *</h4>
        <DropDownListComponent
          allowFiltering
          filtering={
            (onIntegratedPlatformFiltering =
              onIntegratedPlatformFiltering.bind(this))
          }
          dataSource={integratedPlatforms}
          fields={{ text: "text", value: "value" }}
          placeholder="Select integrated platform"
          value={signatureData.integrated_platform_id}
          change={(e) => fetchIntegratedMembers(e.value)}
          width="400px"
        />
      </div>

      <div className="flex flex-col gap-2">
        <h4 className="font-medium">Integrated Member *</h4>
        <DropDownListComponent
          allowFiltering
          filtering={
            (onIntegratedMemberFiltering =
              onIntegratedMemberFiltering.bind(this))
          }
          dataSource={integratedMembers}
          fields={{ text: "text", value: "value" }}
          placeholder="Select integrated member"
          value={signatureData.integrated_member_id}
          change={(e) => {
            if (e.value) {
              setSignatureData((prev) => ({
                ...prev,
                integrated_member_id: e.value,
              }));
              setSelectedIntegratedMember(e.itemData);
              setSignatureWarning((prev) => ({
                ...prev,
                integrated_member_id: null,
              }));
            } else {
              setSignatureWarning((prev) => ({
                ...prev,
                integrated_member_id: "Integrated Member is Required",
              }));
            }
          }}
          cssClass={signatureWarning.integrated_member_id ? "e-error" : ""}
          width="400px"
        />
        {signatureWarning.integrated_member_id && (
          <p className="text-xs text-red-500">
            {signatureWarning.integrated_member_id}
          </p>
        )}
      </div>

      <div className="flex flex-col gap-2">
        <h4 className="font-medium">Type TTD *</h4>
        <DropDownListComponent
          dataSource={ttdTypes}
          fields={{ text: "text", value: "value" }}
          placeholder="Select TTD type"
          value={signatureData.type_ttd}
          change={(e) => {
            if (e.value) {
              setSignatureData((prev) => ({ ...prev, type_ttd: e.value }));

              if (
                (e.value == "signature" &&
                  !selectedIntegratedMember?.ttd_signature) ||
                (e.value == "paraf" && !selectedIntegratedMember?.ttd_paraf)
              ) {
                setSelectedSignatureSource("upload");
              }

              setSignatureWarning((prev) => ({
                ...prev,
                type_ttd: null,
              }));
            } else {
              setSignatureWarning((prev) => ({
                ...prev,
                type_ttd: "Integrated Member is Required",
              }));
            }
          }}
          cssClass={signatureWarning.type_ttd ? "e-error" : ""}
          width="400px"
        />
        {signatureWarning.type_ttd && (
          <p className="text-xs text-red-500">{signatureWarning.type_ttd}</p>
        )}
      </div>

      <h4 className="font-medium">Source Specimen</h4>
      <div className="flex w-full">
        <ul class="flex flex-nowrap w-full gap-2 text-sm bg-gray-100 p-1 rounded-md">
          <li
            onClick={() => {
              if (
                !signatureData.type_ttd ||
                !signatureData.integrated_member_id
              ) {
                return;
              }
              setSelectedSignatureSource("userDetail");
            }}
            className={`w-[50%] text-center px-4 py-2 rounded-md ${
              selectedSignatureSource == "userDetail"
                ? "bg-sky-400 text-white cursor-pointer"
                : !signatureData.type_ttd || !signatureData.integrated_member_id
                  ? "bg-transparent text-gray-400 cursor-not-allowed"
                  : "bg-transparent text-gray-600 cursor-pointer"
            }`}
          >
            Existing User Detail
          </li>
          <li
            onClick={() => {
              setSelectedSignatureSource("upload");
            }}
            className={`w-[50%] text-center px-4 py-2 rounded-md cursor-pointer ${
              selectedSignatureSource == "upload"
                ? "bg-sky-400 text-white"
                : "bg-transparent text-gray-600"
            }`}
          >
            Custom Specimen
          </li>
        </ul>
      </div>

      {selectedSignatureSource == "userDetail" && (
        <div className="flex flex-col gap-2">
          {(signatureData.type_ttd == "signature" &&
            !selectedIntegratedMember?.ttd_signature) ||
          (signatureData.type_ttd == "paraf" &&
            !selectedIntegratedMember?.ttd_paraf) ? (
            <p className="text-xs text-muted">
              *Member tidak mempunyai data {signatureData.type_ttd}, silahkan
              upload custom specimen.
            </p>
          ) : (
            <img
              src={`data:image/*;base64,${signatureData.type_ttd == "signature" ? selectedIntegratedMember?.ttd_signature : selectedIntegratedMember?.ttd_paraf}`}
              alt="Specimen"
              className="w-48 h-32 object-cover border rounded"
            />
          )}
        </div>
      )}
      {selectedSignatureSource == "upload" && (
        <div className="flex flex-col gap-2">
          <h4 className="font-medium">Custom Specimen *</h4>
          <input
            type="file"
            accept="image/png"
            onChange={handleFileUpload}
            className="w-full p-2 text-sm rounded-[4px] border border-slate-500 focus:outline-2 focus:outline-sky-500"
          />
          <span className="text-xs text-slate-500">
            *Format file: <strong>PNG</strong>, ukuran maksimal
            <strong>1 MB</strong>
          </span>

          {signatureWarning.filepath && (
            <p className="text-xs text-red-500">{signatureWarning.filepath}</p>
          )}
          {signatureData.filepath && (
            <img
              src={`data:image/*;base64,${signatureData.filepath}`}
              alt="Specimen"
              className="w-48 h-32 object-cover border rounded"
            />
          )}
        </div>
      )}
    </div>
  );

  const renderSignatureImg = () => (
    <div className="flex flex-col gap-4 w-fit">
      <div className="flex flex-col gap-2">
        <h4 className="font-medium">Specimen *</h4>
        {signatureData.filepath && (
          <img
            src={`data:image/*;base64,${signatureData.filepath}`}
            alt="Specimen"
            className="w-full h-auto object-cover border rounded"
          />
        )}
        {!signatureData.filepath && <p>No Signature Image</p>}
      </div>
    </div>
  );

  const renderSyncFormFields = () => (
    <div className="flex flex-col gap-4 w-fit">
      <div className="flex flex-col gap-2">
        <h4 className="font-medium">Integrated Platform *</h4>
        <DropDownListComponent
          allowFiltering
          filtering={
            (onIntegratedPlatformFiltering =
              onIntegratedPlatformFiltering.bind(this))
          }
          dataSource={integratedPlatforms}
          fields={{ text: "text", value: "value" }}
          placeholder="Select integrated platform"
          value={syncSignatureData.integrated_platform_id}
          change={(e) => fetchIntegratedMembers(e.value)}
          width="400px"
        />
      </div>

      <div className="flex flex-col gap-2">
        <h4 className="font-medium">Integrated Member *</h4>
        <DropDownListComponent
          allowFiltering
          filtering={
            (onIntegratedMemberFiltering =
              onIntegratedMemberFiltering.bind(this))
          }
          dataSource={integratedMembers}
          fields={{ text: "text", value: "value" }}
          placeholder="Select integrated member"
          value={syncSignatureData.integrated_member_id}
          change={(e) => {
            if (e.value) {
              setSyncSignatureData({
                integrated_member_id: e.value,
              });
              setSyncSignatureWarning({
                integrated_member_id: null,
              });
            } else {
              setSyncSignatureWarning({
                integrated_member_id: "Integrated Member is Required",
              });
            }
          }}
          cssClass={syncSignatureWarning.integrated_member_id ? "e-error" : ""}
          width="400px"
        />
        {syncSignatureWarning.integrated_member_id && (
          <p className="text-xs text-red-500">
            {syncSignatureWarning.integrated_member_id}
          </p>
        )}
      </div>
    </div>
  );

  return pageLoading ? (
    <PageLoading />
  ) : (
    <div className="m-2 md:m-10 mt-24 px-2 py-10 md:p-10 bg-white rounded-3xl">
      <div className="flex justify-between items-end pb-4">
        <Header title="Signature Data" />

        <div className="flex flex-wrap gap-2">
          <button
            style={{ backgroundColor: currentColor }}
            className="text-white py-2 px-4 rounded-md text-sm flex items-center gap-2 justify-center flex-nowrap"
            onClick={handleSync}
          >
            <FaSync className="w-3 h-3" />
            <div className="text-nowrap">Sync Signature</div>
          </button>
          <button
            style={{ backgroundColor: currentColor }}
            className="text-white py-2 px-4 rounded-md text-sm flex items-center gap-2 justify-center flex-nowrap"
            onClick={handleAdd}
          >
            <FaPlus className="w-3 h-3" />
            <div className="text-nowrap">Add Signature</div>
          </button>
        </div>
      </div>

      <div className="overflow-x-auto">
        <div className="w-full cursor-pointer">
          <GridComponent
            dataSource={signatureList}
            width="auto"
            allowPaging
            allowSorting
            allowTextWrap={true}
            pageSettings={{
              pageCount: 5,
              pageSizes: ["All", "10", "25", "50"],
            }}
            textWrapSettings={{ wrapMode: "Content" }}
            toolbar={["Search", "ExcelExport"]}
            queryCellInfo={queryCellInfo}
            allowExcelExport={true}
            toolbarClick={toolbarClick}
            dataBound={dataBound}
            ref={gridRef}
          >
            <ColumnsDirective>
              <ColumnDirective
                field="No"
                headerText="No"
                textAlign="Center"
                width={50}
                type="Number"
              />
              <ColumnDirective
                field="Uuid"
                headerText="Action"
                textAlign="Center"
                isPrimaryKey={true}
                template={actionTemplate}
                minWidth={250}
              />
              <ColumnDirective
                field="IntegratedPlatformName"
                headerText="Integrated Platform"
                minWidth={150}
              />
              <ColumnDirective
                field="IntegratedMemberName"
                headerText="Member"
                minWidth={150}
              />
              <ColumnDirective
                field="TypeTtd"
                headerText="Type TTD"
                minWidth={150}
              />
              <ColumnDirective
                field="Filepath"
                headerText="Filepath"
                template={signatureImgTemplate}
                minWidth={250}
              />
              <ColumnDirective
                field="CreatedAt"
                headerText="Created At"
                minWidth={200}
              />
            </ColumnsDirective>
            <Inject
              services={[Search, Toolbar, Page, Sort, Resize, ExcelExport]}
            />
          </GridComponent>
        </div>
      </div>

      {/* Add Modal */}
      {toggleAdd && (
        <div className="overflow-auto absolute z-[99] top-0 left-0 flex justify-center w-full min-h-screen h-full overflow-y-auto py-40 px-[100px] bg-slate-800/50">
          <div className="bg-white flex flex-col gap-2 w-full max-w-[464px] h-fit rounded-xl p-8">
            <div className="flex items-center justify-between">
              <h1 className="text-xl font-medium text-nowrap">Add Signature</h1>
              <div
                className="cursor-pointer p-2"
                onClick={() => {
                  setToggleAdd(false);
                  resetForm();
                }}
              >
                <FaXmark className="w-4 h-4" />
              </div>
            </div>
            <hr />

            {renderFormFields()}

            <div className="flex justify-end items-center gap-2 mt-6">
              <button
                className="text-gray-600 w-24 py-2 px-4 rounded-md text-sm border border-gray-300"
                onClick={() => {
                  setToggleAdd(false);
                  resetForm();
                }}
              >
                Cancel
              </button>
              <button
                disabled={loading}
                style={{ backgroundColor: currentColor }}
                className={
                  "text-white py-2 px-4 rounded-md text-sm " +
                  (loading ? "cursor-not-allowed opacity-50" : "cursor-pointer")
                }
                onClick={() => handleSubmit(false)}
              >
                {!loading ? "Add Signature" : "Loading..."}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Edit Modal */}
      {toggleEdit && (
        <div className="overflow-auto absolute z-[99] top-0 left-0 flex justify-center w-full min-h-screen h-full overflow-y-auto py-40 px-[100px] bg-slate-800/50">
          <div className="bg-white flex flex-col gap-2 w-full max-w-[464px] h-fit rounded-xl p-8">
            <div className="flex items-center justify-between">
              <h1 className="text-xl font-medium">Edit Signature</h1>
              <div
                className="cursor-pointer p-2"
                onClick={() => {
                  setToggleEdit(false);
                  resetForm();
                }}
              >
                <FaXmark className="w-4 h-4" />
              </div>
            </div>
            <hr />

            {renderFormFields()}

            <div className="flex justify-end items-center gap-2 mt-6">
              <button
                className="text-gray-600 w-24 py-2 px-4 rounded-md text-sm border border-gray-300"
                onClick={() => {
                  setToggleEdit(false);
                  resetForm();
                }}
              >
                Cancel
              </button>
              <button
                disabled={loading}
                style={{ backgroundColor: currentColor }}
                className={
                  "text-white py-2 px-4 rounded-md text-sm " +
                  (loading ? "cursor-not-allowed opacity-50" : "cursor-pointer")
                }
                onClick={() => handleSubmit(true)}
              >
                {!loading ? "Update Signature" : "Loading..."}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Signature Image Modal */}
      {toggleSignatureImg && (
        <div className="overflow-auto absolute z-[99] top-0 left-0 flex justify-center w-full min-h-screen h-full overflow-y-auto py-40 px-[100px] bg-slate-800/50">
          <div className="bg-white flex flex-col gap-2 w-full max-w-[464px] h-fit rounded-xl p-8">
            <div className="flex items-center justify-between">
              <h1 className="text-xl font-medium">Signature Image</h1>
              <div
                className="cursor-pointer p-2"
                onClick={() => {
                  setToggleSignatureImg(false);
                  resetForm();
                }}
              >
                <FaXmark className="w-4 h-4" />
              </div>
            </div>
            <hr />

            {renderSignatureImg()}

            <div className="flex justify-end items-center gap-2 mt-6">
              <button
                className="text-gray-600 w-24 py-2 px-4 rounded-md text-sm border border-gray-300"
                onClick={() => {
                  setToggleSignatureImg(false);
                  resetForm();
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Sync Modal */}
      {toggleSync && (
        <div className="overflow-auto absolute z-[99] top-0 left-0 flex justify-center w-full min-h-screen h-full overflow-y-auto py-40 px-[100px] bg-slate-800/50">
          <div className="bg-white flex flex-col gap-2 w-full max-w-[464px] h-fit rounded-xl p-8">
            <div className="flex items-center justify-between">
              <h1 className="text-xl font-medium">Sync Signature Specimen</h1>
              <div
                className="cursor-pointer p-2"
                onClick={() => {
                  setToggleSync(false);
                  resetSyncForm();
                }}
              >
                <FaXmark className="w-4 h-4" />
              </div>
            </div>
            <hr />

            {renderSyncFormFields()}

            <div className="flex justify-end items-center gap-2 mt-6">
              <button
                className="text-gray-600 w-24 py-2 px-4 rounded-md text-sm border border-gray-300"
                onClick={() => {
                  setToggleSync(false);
                  resetSyncForm();
                }}
              >
                Cancel
              </button>
              <button
                disabled={syncSignatureWarning.integrated_member_id || loading}
                style={{ backgroundColor: currentColor }}
                className={
                  "text-white py-2 px-4 rounded-md text-sm " +
                  (syncSignatureWarning.integrated_member_id || loading
                    ? "cursor-not-allowed opacity-50"
                    : "cursor-pointer")
                }
                onClick={() => handleSyncSubmit()}
              >
                {!loading ? "Sync Signature Specimen" : "Loading..."}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {toggleDelete && (
        <div className="overflow-auto absolute z-[99] top-0 left-0 flex justify-center w-full min-h-screen h-full overflow-y-auto py-40 px-[100px] bg-slate-800/50">
          <div className="bg-white flex flex-col gap-4 w-full max-w-[400px] h-fit rounded-xl p-8">
            <div className="flex items-center justify-between">
              <h1 className="text-xl font-medium">Delete Signature</h1>
              <div
                className="cursor-pointer p-2"
                onClick={() => {
                  setToggleDelete(false);
                  resetForm();
                }}
              >
                <FaXmark className="w-4 h-4" />
              </div>
            </div>
            <hr />

            <div className="text-center">
              <FaTrash className="w-16 h-16 text-red-500 mx-auto mb-4" />
              <h2 className="text-lg font-semibold mb-2">Are you sure?</h2>
              <p className="text-gray-600 mb-4">
                Do you really want to delete the signature? This action cannot
                be undone.
              </p>
            </div>

            <div className="flex justify-center items-center gap-2 mt-4">
              <button
                className="text-gray-600 w-24 py-2 px-4 rounded-md text-sm border border-gray-300"
                onClick={() => {
                  setToggleDelete(false);
                  resetForm();
                }}
              >
                Cancel
              </button>
              <button
                disabled={deleteLoading}
                className={
                  "bg-red-500 text-white w-24 py-2 px-4 rounded-md text-sm " +
                  (deleteLoading
                    ? "cursor-not-allowed opacity-50"
                    : "cursor-pointer")
                }
                onClick={handleDeleteConfirm}
              >
                {!deleteLoading ? "Delete" : "Deleting..."}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SignatureSpecimen;
